import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  Button,
  Dialog,
  Checkbox,
  TextField,
  Typography,
  DialogContent,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";
import { DialogTitleComp } from "../../Utils/Component";
import { CREATE_REASON_OF_LOSS_MEMBER, UPDATE_REASON_OF_LOSS_MEMBER } from "../../Schema/ReasonOfLossMember";

export default function ReasonOfLossMemberForm({
  open,
  editData,
  setRefetch,
  dialogTitle,
  handleClose,
  hideBackdrop,
}) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createReasonOfLossMember] = useMutation(CREATE_REASON_OF_LOSS_MEMBER, {
    onCompleted: ({ createReasonOfLossMember }) => {
      setLoading(false);
      if (createReasonOfLossMember?.isSuccess === true) {
        setAlert(true, "success", createReasonOfLossMember?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createReasonOfLossMember?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false); 
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateReasonOfLossMember] = useMutation(UPDATE_REASON_OF_LOSS_MEMBER, {
    onCompleted: ({ updateReasonOfLossMember }) => {
      setLoading(false);
      if (updateReasonOfLossMember?.isSuccess === true) {
        setAlert(true, "success", updateReasonOfLossMember?.message);
        handleClose(); 
        setRefetch();
      } else {
        setAlert(true, "error", updateReasonOfLossMember?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    reason_title: Yup.string().required(t("required")),
    isDefault: Yup.boolean().required(t("required")),
  });

  const formik = useFormik({
    initialValues: {
      reason_title: "",
      isDefault: false,
    }, 
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      if (dialogTitle === "Create") {  
        createReasonOfLossMember({
          variables: {
            input: {
              ...values,
            },
          },
        });
      } else {
        updateReasonOfLossMember({
          variables: {
            id: editData?._id,
            input: {
              ...values,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("isDefault", editData?.isDefault);
      setFieldValue("reason_title", editData?.reason_title);
    }
  }, [editData, open]);
  return (
    <Dialog
      fullWidth
      open={open}
      maxWidth="sm"
      className="dialog-container"
      hideBackdrop={hideBackdrop}
    >
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_reason_of_loss_member")
            : t("modal_title_update_reason_of_loss_member")
        }
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_reason")}
                </Typography>
                <TextField
                  className="text-field"
                  size="small"
                  fullWidth

                  placeholder={t("thead_reason")}
                  {...getFieldProps("reason_title")}
                  error={Boolean(touched.reason_title && errors.reason_title)}
                  helperText={touched.reason_title && errors.reason_title}
                />
              </Grid>

              <Grid item xs={12}>
                <Stack direction="row" alignItems="center" >
                  <Checkbox
                    checked={values?.isDefault}
                    onChange={({ target }) => setFieldValue("isDefault", Boolean(target?.checked))}
                  />
                  <Typography className={t("class-name-field-title")} sx={{ marginTop: 1 }}>
                    {t("thead_default")}
                  </Typography>
                </Stack>
              </Grid>



              <Grid item xs={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className={t("class-btn-create")}
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {dialogTitle === "Create" ? t("create") : t("update")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
